<template>
  <div v-frag>
    <CardIeaAppMain
      colorCard="#A7BA38"
      oncontextmenu="return false;"
      onmousedown="return false;"
      onselectstart="return false;"
      oncopy="return false;"
      oncut="return false;"
    >
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12" v-if="examen">
        <v-expansion-panels flat style="visibility: hidden">
          <v-expansion-panel>
            <v-expansion-panel-header>
              <h2>
                <CountDown
                  @siguientePregunta="guardarResultado()"
                  :testFinalizado="testFinalizado"
                  :seconds="tiempoRespuesta"
                />
              </h2>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-sheet class="black--text">{{ descripcion }}</v-sheet>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-card elevation="11" outlined shaped>
          <v-card-title class="d-flex justify-left pl-16"
            >{{ preguntaActual.pregunta }}
          </v-card-title>
          <v-card-text class="pl-12">
            <v-container fluid v-if="monoOptions == false">
              <v-col
                cols="12"
                sm="6"
                md="6"
                v-for="respuesta in respuestasOpciones"
                :key="respuesta.id"
              >
                <v-checkbox
                  v-model="respuesta.seleccionada"
                  color="primary"
                  hide-details
                >
                  <template v-slot:label>
                    <div>
                      <strong>{{ respuesta.respuesta }}</strong>
                    </div>
                  </template>
                </v-checkbox>
              </v-col>
            </v-container>
            <v-container fluid v-else>
              <v-col cols="12" sm="6" md="6">
                <v-radio-group v-model="selected">
                  <v-radio
                    v-for="respuesta in respuestasOpciones"
                    :key="respuesta.id"
                    :label="`${respuesta.respuesta}`"
                    :value="respuesta.id"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <div class="pl-16 mb-10">
              <v-btn
                color="primary"
                :disabled="indicePreguntaActual == 0 ? true : false"
                elevation="7"
                large
                @click="pregunta(-1)"
                >Anterior</v-btn
              >
            </div>
            <div class="pl-16 mb-10">
              <v-btn
                color="primary"
                elevation="7"
                large
                v-if="this.preguntas.length - 1 == this.indicePreguntaActual"
                @click="pregunta(1, true)"
              >
                <span>Terminar Examen</span>
              </v-btn>

              <v-btn
                color="primary"
                elevation="7"
                large
                v-else-if="this.preguntas.length >= this.indicePreguntaActual"
                @click="pregunta(1)"
              >
                <span>Siguiente</span>
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12" v-else>
        <div v-if="tipo == 'Examen Final'">
          <div class="pl-16 mb-10 d-flex justify-center">
            <h3>Estimado alumno<br /></h3>
          </div>

          <div class="pl-16 mb-10 d-flex justify-center">
            <ul>
              <!--<li>
                Recuerde que el examen <b>NO</b> puede ser enviado incompleto.
              </li>
              -->
              <li>
                <b>NO</b> debe cerrar la sesión antes de presionar el botón
                <b>ENVIAR </b>, sino su examen quedará anulado.
              </li>
              <li>
                El tiempo para presentar el examen es de
                <b>{{ tiempo_examen }} minutos</b>.
              </li>
            </ul>
          </div>
        </div>

        <div class="pl-16 mb-10 d-flex justify-center">
          <v-btn
            color="success"
            elevation="7"
            large
            v-on:click="examen = true"
            @click="pregunta()"
            >Empezar</v-btn
          >
        </div>
      </v-col>

      <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="610">
          <v-card>
            <v-card-title
              class="headline"
              onselectstart="return false;"
              oncontextmenu="return false;"
              >¿ Está Seguro de finalizar el test ?
            </v-card-title>
            <v-card-text>
              <v-expansion-panels
                onselectstart="return false;"
                oncontextmenu="return false;"
              >
                <v-expansion-panel
                  v-for="(item, index) in datosRespuestas"
                  :key="index"
                >
                  <v-expansion-panel-header>
                    {{ item.pregunta.pregunta }}
                    <template v-slot:actions>
                      <v-icon color="primary"> $expand </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ul
                      v-for="(respuesta, index) in item.opcionesRespuestas"
                      :key="index"
                    >
                      <li v-if="respuesta.seleccionada == true">
                        {{ respuesta.respuesta }}
                      </li>
                    </ul>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn text @click="dialog = false"> Cancelar </v-btn>
              <v-btn color="green darken-1" text @click="guardarResultado()">
                Finalizar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </CardIeaAppMain>
  </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";
import CountDown from "../../components/CountDown";

export default {
  name: "examen",
  components: {
    CardIeaAppMain,
    CountDown,
  },
  data() {
    return {
      ex4: ["primary"],
      test: "Prueba del titulo del test",
      descripcion: "esta es una descripcion provicional",
      preguntas: {},
      examen: false,
      indicePreguntaActual: 0,
      preguntaActual: {},
      respuestasOpciones: {},
      tiempoRespuesta: null,
      monoOptions: false,
      radioGroup: 1,
      selected: null,
      resp: {},
      dialog: false,
      testFinalizado: false,
      datosRespuestas: [],
      idTest: null,
      idExamen: null,
      validar: false,
      alumnoTest_id: null,
      tipo: null,
      tiempo_examen: null,
      cantidadPreguntas: null,
    };
  },
  mounted() {
    if (
      this.$store.getters.user.borrado == 1 ||
      this.$store.getters.user.alumno_mora == true
    ) {
      this.$router.push({
        name: "Home",
      });
    }
    this.test = "Prueba";
    this.idtest = this.$route.params.test;
    this.idExamen = this.$route.params.examen;
    this.$API
      .get({
        url:
          "pyr-preguntas/select/" +
          this.idtest +
          "/" +
          this.$store.getters.user.IDStB +
          "/" +
          this.idExamen,
        data: {},
      })
      .then((res) => {
        this.tipo = res.tipo;
        this.cantidadPreguntas = res.questions.length;
        this.preguntas = res.questions;
        this.alumnoTest_id = res.alumnoRegistrado.id;
        this.tiempo_examen = res.total_evaluacion;
        let d = new Date("0001-01-01T" + res.total_evaluacion);
        console.log(d);
        //let minutos = d.getHours() * 60 + d.getMinutes();
        this.tiempoRespuesta = res.total_evaluacion * 60;
      })
      .catch(() => {
        this.$router.push({
          name: "Home",
        });
      });
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    pregunta(index = 0, ultimapregunta = false) {
      if (index != 0) {
        this.guardarRespuestas();
      }

      if (index == 0) {
        this.$API
          .post({
            url: "guardar-horaInicio-examen",
            data: {
              alumnoTest_id: this.alumnoTest_id,
            },
          })
          .then(() => {
            console.log("hora guardada correctamente");
          })
          .catch((err) => {
            console.log(err);
          });
      }

      this.indicePreguntaActual = index + this.indicePreguntaActual;

      console.log(
        "total " + this.cantidadPreguntas,
        "index " + index,
        "indiceActual " + this.indicePreguntaActual
      );

      if (index == -1) {
        let respuestas = this.datosRespuestas[this.indicePreguntaActual];
        this.respuestasOpciones = respuestas.opcionesRespuestas;
        this.preguntaActual = this.preguntas[this.indicePreguntaActual];

        let selectMono = respuestas.respuestasSeleccionadas;
        this.selected = selectMono[0];
      } else {
        if (this.datosRespuestas[this.indicePreguntaActual] != null) {
          let respuestas = this.datosRespuestas[this.indicePreguntaActual];
          this.respuestasOpciones = respuestas.opcionesRespuestas;
          this.preguntaActual = this.preguntas[this.indicePreguntaActual];

          let selectMono = respuestas.respuestasSeleccionadas;
          this.selected = selectMono[0];
        } else if (this.preguntas.length > this.indicePreguntaActual) {
          this.preguntaActual = this.preguntas[this.indicePreguntaActual];
          this.preguntaActual.tipo == "Multi Option"
            ? (this.monoOptions = false)
            : (this.monoOptions = true);

          this.$API
            .get({
              url: `pyr-pregunta/${this.preguntaActual.id}`,
              data: {},
            })
            .then((res) => {
              this.respuestasOpciones = res.respuestas;
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          this.testFinalizado = true;
          this.tiempoRespuesta = 0;
          this.dialog = true;
        }
      }

      if (ultimapregunta == true) {
        this.mostrarDialog();
        return;
      }
    },
    guardarRespuestas() {
      if (this.preguntaActual.tipo == "Multi Option") {
        this.resp = {
          pregunta: this.preguntaActual,
          opcionesRespuestas: this.respuestasOpciones,
          respuestasSeleccionadas: this.respuestasOpciones
            .filter((respuesta) => respuesta.seleccionada == true)
            .map((r) => r.id),
        };
      } else {
        this.respuestasOpciones.forEach((element) => {
          element.seleccionada = false;
          if (element.id === this.selected) {
            element.seleccionada = true;
          }
        });

        this.resp = {
          pregunta: this.preguntaActual,
          opcionesRespuestas: this.respuestasOpciones,
          respuestasSeleccionadas: this.respuestasOpciones
            .filter((respuesta) => respuesta.id == this.selected)
            .map((r) => r.id),
        };
      }

      this.datosRespuestas[this.indicePreguntaActual] = this.resp;
      const parsed = JSON.stringify(this.datosRespuestas);
      localStorage.setItem("respu", parsed);
      this.resp = {};
      this.selected = null;
      return true;
    },

    guardarResultado() {
      this.guardarRespuestas();

      this.$API
        .post({
          url: "guardar-respuestas",
          data: {
            respuestas: JSON.stringify(this.datosRespuestas),
            idExamen: this.idExamen,
            alumnoTest_id: this.alumnoTest_id,
          },
        })
        .then(() => {
          this.$API
            .post({
              url: "guardar-horaFin-examen",
              data: {
                alumnoTest_id: this.alumnoTest_id,
              },
            })
            .then(() => {
              console.log("hora guardada correctamente");
            })
            .catch((err) => {
              console.log(err);
            });

          this.dialog = false;
          this.$router.push({
            name: "Home",
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    mostrarDialog() {
      this.dialog = true;
    },
  },
};
</script>
